export enum ValidatorsEnum {
    None = 0,
    CurveSolver = 1,
    BimValidator = 2,
    SlopeGuard = 3
  }